import React from "react";

interface DivProps {
    id?: string
    title?: string
    visible?: boolean
    className?: string
    height?: number
    width?: number
    maxWidth?: number
    limitedText?: boolean
    children?: any
    onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

function Div(props: DivProps) {

    const className = () => {
        var cls = props.className ?? "";

        if (props.onClick) cls += " cursor-pointer";
        if (props.limitedText) cls += " limited-text"
        return cls;
    }

    return (
        props.visible == undefined || props.visible ?
            <div id={props.id} title={props.title}
                className={className()}
                onClick={props.onClick}
                style={{
                    width: props.width,
                    height: props.height,
                    maxWidth: props.maxWidth
                }}>
                {props.children}
            </div>
            :
            <></>
    )
}

export default Div;

